import React from 'react';

export const preventDefaultHandler = (event: React.MouseEvent) => {
  event.preventDefault();
};
